import React, { FC, SVGProps } from 'react'
const ArrowRightIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17} height={18} fill="none" {...props}>
    <path
      fill="#11245A"
      fillRule="evenodd"
      d="m7.592 2.603-.002.002 5.58 5.59H1a1 1 0 1 0 0 2h12.17l-5.58 5.59.002.002a.996.996 0 1 0 1.413 1.403L17 9.195 9.034 1.23a.996.996 0 1 0-1.442 1.373Z"
      clipRule="evenodd"
    />
  </svg>
)
export default ArrowRightIcon
